<template>
  <div>
    <div class="flex flex-col justify-center min-h-screen bg-darkma pt-6">
      <div class="text-center text-cryma font-black text-3xl md:text-6xl pb-6">WORKED ON <span class="font-normal">🔨</span></div>
      <div class="flex justify-center flex-wrap">
        <Card url="https://streamerbans.com/">
          <template v-slot:title>
            <span class="font-normal">🔗</span> StreamerBans
          </template>
          <template v-slot:body>
            <p class="text-black text-base md:text-lg">
              Provides
              <span class="font-semibold">statistical insights</span> and
              <span class="font-semibold">ban histories</span> of
              <span class="font-semibold">Twitch partners</span>.
            </p>
            <p class="text-black text-base md:text-lg pt-4">
              Initially started as a
              <a href="https://twitter.com/StreamerBans">
                <span class="whitespace-no-wrap">
                  <i class="fab fa-twitter icon-cryma px-1"></i>
                  <span class="font-semibold underline">Twitter</span>
                </span>
              </a>
              bot.
            </p>
          </template>
          <template v-slot:hashtags>
            <CardHashtag>#csharp</CardHashtag>
            <CardHashtag>#php</CardHashtag>
            <CardHashtag>#laravel</CardHashtag>
            <CardHashtag>#vue</CardHashtag>
          </template>
        </Card>
        <Card url="https://dontbuy.games/">
          <template v-slot:title>
            <span class="font-normal">🔗</span> Don't Buy Games
          </template>
          <template v-slot:body>
            <p class="text-black text-base md:text-lg">
              Web service for tracking
              <span class="font-semibold">game subscriptions</span> like Xbox
              Game Pass, EA Play and Ubisoft +. Currently holding
              <span
                class="font-semibold"
              >650+ games</span>.
            </p>
            <p class="text-black text-base md:text-lg pt-4">
              Short summaries are posted on
              <a href="https://twitter.com/DontBuyGames">
                <span class="whitespace-no-wrap">
                  <i class="fab fa-twitter icon-cryma px-1"></i>
                  <span class="font-semibold underline">Twitter</span>
                </span>
              </a>.
            </p>
          </template>
          <template v-slot:hashtags>
            <CardHashtag>#rust</CardHashtag>
            <CardHashtag>#react</CardHashtag>
            <CardHashtag>#nextjs</CardHashtag>
            <CardHashtag>#laravel</CardHashtag>
          </template>
        </Card>
        <Card url="https://github.com/AlternateLife">
          <template v-slot:title>
            <span class="font-normal">🔗</span> Alternate-Life
          </template>
          <template v-slot:body>
            <p class="text-black text-base md:text-lg">
              Former German
              <span class="font-semibold">Grand Theft Auto 5</span> roleplay
              server based on
              <span class="font-semibold">RAGE Multiplayer</span>.
            </p>
            <p class="text-black text-base md:text-lg pt-4">
              Open-Source work can be found on
              <a href="https://github.com/AlternateLife">
                <span class="whitespace-no-wrap">
                  <i class="fab fa-github pr-1"></i>
                  <span class="font-semibold underline">GitHub</span>
                </span>
              </a>.
            </p>
          </template>
          <template v-slot:hashtags>
            <CardHashtag>#csharp</CardHashtag>
            <CardHashtag>#typescript</CardHashtag>
            <CardHashtag>#cpp</CardHashtag>
          </template>
        </Card>
      </div>
    </div>
    <div class="flex flex-col justify-center min-h-screen bg-darkma">
      <div class="text-center font-black text-3xl md:text-6xl pb-6 text-cryma">
        <span class="font-normal">💯</span> OPEN-SOURCE
      </div>
      <div class="flex justify-center flex-wrap">
        <Card url="https://github.com/Geplauder">
          <template v-slot:title>
            <span class="font-normal">🔗</span> Geplauder
          </template>
          <template v-slot:body>
            <p class="text-black text-base md:text-lg">
              Geplauder is a work-in-progress
              <span class="font-semibold">text-communication service</span>, heavily inspired by Discord and Guilded.
            </p>
            <p class="text-black text-base md:text-lg pt-4">
              The backend is written in
              <span class="font-semibold">Rust</span> with actix-web and sqlx. The frontend is written in
              <span class="font-semibold">TypeScript</span> with React and Redux Toolkit.
            </p>
          </template>
          <template v-slot:hashtags>
            <CardHashtag>#rust</CardHashtag>
            <CardHashtag>#actix-web</CardHashtag>
            <CardHashtag>#typescript</CardHashtag>
            <CardHashtag>#react</CardHashtag>
          </template>
        </Card>
        <Card url="https://github.com/Cryma/cryv-rs">
          <template v-slot:title>
            <span class="font-normal">🔗</span> cryv-rs
          </template>
          <template v-slot:body>
            <p class="text-black text-base md:text-lg">
              Work-in-progress alternative
              <span class="font-semibold">multiplayer modification</span> for
              <span class="font-semibold">Grand Theft Auto V</span> written in
              Rust.
            </p>
            <p class="text-black text-base md:text-lg pt-4">
              This project is purely for
              <span class="font-semibold">educational purposes</span>.
            </p>
          </template>
          <template v-slot:hashtags>
            <CardHashtag>#rust</CardHashtag>
            <CardHashtag>#gta5</CardHashtag>
            <CardHashtag>#multiplayer</CardHashtag>
          </template>
        </Card>
        <Card url="https://github.com/Cryma/TwitchApi.Net">
          <template v-slot:title>
            <span class="font-normal">🔗</span> TwitchApi.Net
          </template>
          <template v-slot:body>
            <p class="text-black text-base md:text-lg">
              Lightweight and thread-safe
              <span class="font-semibold">C# wrapper</span> for the
              <span class="font-semibold">Twitch Helix</span> API.
            </p>
            <p class="text-black text-base md:text-lg pt-4">
              Currently used in production by
              <span class="font-semibold">StreamerBans</span>.
            </p>
          </template>
          <template v-slot:hashtags>
            <CardHashtag>#csharp</CardHashtag>
            <CardHashtag>#twitch</CardHashtag>
            <CardHashtag>#api</CardHashtag>
          </template>
        </Card>
      </div>
    </div>
    <div class="flex flex-col justify-center h-screen bg-darkma">
      <div class="text-center text-cryma text-3xl md:text-6xl font-black">
        <span class="font-normal">📱</span> SOCIAL MEDIA
      </div>
      <div class="text-center text-white text-xl md:text-4xl">/</div>
      <div class="text-center text-cryma text-xl md:text-4xl">
        <a href="https://github.com/Cryma">
          <i class="fab fa-github text-white pr-2"></i>
          <span class="font-bold underline">Cryma</span>
        </a>
      </div>
      <div class="text-center text-cryma text-xl md:text-4xl">
        <a href="https://twitter.com/crymaofficial">
          <i class="fab fa-twitter text-white pr-2"></i>@
          <span class="font-bold underline">CrymaOfficial</span>
        </a>
      </div>
      <div class="text-center text-cryma text-xl md:text-4xl">
        <i class="fab fa-discord text-white pr-2"></i>
        <span class="font-bold">CrymaOfficial#7780</span>
      </div>
    </div>
  </div>
</template>
<script>
import Card from "./components/Card.vue";
import CardHashtag from "./components/CardHashtag.vue";

export default {
  components: {
    Card,
    CardHashtag,
  },
};
</script>
